import { action, observable } from 'mobx';
import { deleteCookie, isLocalStorageSupported } from '../utils/helpers';
import { checkAuthentication, getProctorTypes, getTimezones } from '../lib/apiClient';
import  secureLocalStorage  from  "react-secure-storage";


function SessionStore() {


  let obx = observable({
    authenticated: false,
    user: null,
    firstName: "",
    lastName: "",
    email : "",
    role: 'learner',
    mode: 'production',
    ids: {},
    isSetup: false,
    hasSessionStorage: isLocalStorageSupported(),
    tokenSet: false,
    activeBroadcasts : [],
    sidArray : [],
    matchingBroadcasts : [],
    selectedBroadcastMessage : null,
    proctorTypes : [],
    proctorSubTypes : {},
    timezones: {},
    getLocalStorage: action(function(data) {
      obx.userData = data;
    }),
    
    setup: action (async function() {
        try {
          
          const authenticationCheck = await checkAuthentication();

          obx.role = authenticationCheck.data.role;
          obx.mode = authenticationCheck.data.mode;

          obx.ids.deploymentSid = authenticationCheck.data?.deploymentSid;
          obx.ids.courseSid = authenticationCheck.data?.courseSid;
          obx.ids.installSid = authenticationCheck.data?.installSid;
          obx.ids.courseSid = authenticationCheck.data?.courseSid;
          obx.ids.userSid = authenticationCheck.data?.userSid;
          obx.ids.integrationSid = authenticationCheck.data?.integrationSid;
          obx.ids.enrollmentSid = authenticationCheck.data?.enrollmentSid;

          
          // now get all the proctor types.

            const types = await getProctorTypes();
            obx.proctorTypes = types.data.results;
            obx.proctorSubTypes = types.data.results.reduce((acc, item) => {
              item.subCategories.forEach(subCategory => {
                  acc[subCategory.sid] = subCategory;
              });
              return acc;
              }, {});
              
          // get timezones

          const timezones = await getTimezones();
         
          obx.timezones = timezones.data.results.reduce((tzs, timezone) => {
            tzs[timezone.sid] = timezone;
            return tzs;
        }, {});
        

          obx.isSetup = true;

        return true;
      }
      catch (err) {
        console.log("error setting up");
        console.log(err);
        return false;
      }
    }),

    setMatchingBroadcasts: action(async function () {
      // Create a Set from the values of the SIDs object for quick lookup
      const sidsSet = new Set(Object.values(obx.ids));

      // Filter notifications where any target's Sid__c is in the sidsSet
      const filteredNotifications = obx.activeBroadcasts.filter(notification => 
          notification.targets.some(target => sidsSet.has(target.sid))
      );

      obx.matchingBroadcasts = filteredNotifications || [];

      return true;    
    }),

    getUser: action (async function(sessionToken, outsetaToken) {
      
      try {
      
        const result = {
            authenticated: true,
            user: null,
            message: null
        }

        if(result.authenticated){
          

          //secureLocalStorage.setItem('authenticated', true);
          
        }else{
          secureLocalStorage.clear('user');
        }

        return result;
      }
      catch (err) {
        return err;
      }
    }),

    removeLocalStorage: action(function() {
      if(obx.hasSessionStorage) {
        secureLocalStorage.removeItem('userData');
      } else {
        deleteCookie('userData');
      }
    }),
    
    logout: action(async function () {
      secureLocalStorage.clear();
      obx.resetStores();
      return true;    
    }),

    resetStores: action(function() {
      // Reset session store (this)
      obx.userData = null;
      obx.profile = null;
      obx.account = null;
      obx.bucket = null;
      obx.buckets = [];
      obx.streamViews = [];
    }),

    getToken: action(function() {
      const queryParameters = new URLSearchParams(window.location.search)
      return secureLocalStorage.getItem('token') || queryParameters.get("token") || "";
    }),

    setToken: action(function() {
      const queryParameters = new URLSearchParams(window.location.search)
      if(queryParameters.get("token")){
        secureLocalStorage.setItem("token", queryParameters.get("token"));

        queryParameters.delete('token'); // Replace 'yourParam' with the query param you want to remove
        
        let newUrl = `${window.location.pathname}`;

        if(queryParameters.size){  
          newUrl = `${newUrl}?${queryParameters.toString()}`;
        } 
        
        window.history.pushState(null, '', newUrl);

      }
    })
    
  });
  
  async function init() {

    
    obx.setToken();



    await obx.setup();
  }

  init();

  return obx;

}

export default SessionStore();